export default "__VITE_ASSET__DtN0bqpa__"